import { BaseTariffPage } from "@/components/tarif/BaseTariffPage";
import { Shield, Phone, CheckCircle2, Clock, FileText, Users, Building2, Stethoscope, Hospital, AlertCircle, Award } from "lucide-react";

const VHV_COLOR = "#FFCC00";

const VhvTarif = () => {
  const heroFeatures = [
    { icon: Award, title: "Digital Star", subtitle: "Ausgezeichnet" },
    { icon: CheckCircle2, title: "Unbegr. Sublimits", subtitle: "Max. Flexibilität" },
    { icon: Shield, title: "Bis 5 Mio. €", subtitle: "Deckungssumme" }
  ];

  const coverageAreas = [
    {
      icon: Shield,
      title: "Eigenschäden",
      items: [
        "IT-Forensik und Schadensanalyse",
        "Datenwiederherstellung und Systemreparatur",
        "Betriebsunterbrechung durch Cyberangriff",
        "Cyber-Erpressung und Lösegeldzahlungen",
        "Kosten für Krisenmanagement"
      ]
    },
    {
      icon: AlertCircle,
      title: "Cyber-Haftpflicht",
      items: [
        "DSGVO-Bußgelder und Schadensersatz",
        "Datenschutzverletzungen & Meldepflichten",
        "Ansprüche Dritter bei Datenlecks",
        "Abwehr unberechtigter Ansprüche",
        "Rechtsschutz bei Cyber-Vorfällen"
      ]
    },
    {
      icon: Phone,
      title: "24/7 Assistance",
      items: [
        "Cyber-Notfall-Hotline rund um die Uhr",
        "Sofortige Expertenunterstützung",
        "Koordination aller Dienstleister",
        "PR- und Krisenkommunikation",
        "Persönlicher Schadenmanager"
      ]
    },
    {
      icon: CheckCircle2,
      title: "Weltweiter Schutz",
      items: [
        "Versicherungsschutz weltweit gültig",
        "Keine geografischen Einschränkungen",
        "Auch bei Cloud-Servern im Ausland",
        "Unbegrenzte Sublimits-Struktur",
        "Flexible Deckungssummen"
      ]
    }
  ];

  const targetGroups = [
    {
      icon: Stethoscope,
      title: "Hausarztpraxen",
      description: "Einzelpraxen mit hoher Patientenfrequenz und sensiblen Gesundheitsdaten",
      benefits: [
        "Mehrfach ausgezeichneter Schutz mit FFF-Rating",
        "Unbegrenzte Sublimits für maximale Flexibilität",
        "24/7-Hotline für schnelle Hilfe im akuten Notfall",
        "Bündelrabatte mit Berufshaftpflicht verfügbar"
      ],
      recommendation: "Empfohlene Deckung: 500.000 - 1.000.000 €"
    },
    {
      icon: Users,
      title: "Facharztpraxen",
      description: "Spezialisierte Praxen mit umfangreichen digitalen Diagnosesystemen",
      benefits: [
        "Umfassender Schutz teurer medizinischer IT-Systeme",
        "Absicherung bei Ausfall bildgebender Verfahren",
        "DSGVO-Schutz bei Datenübermittlung an Dritte",
        "Betriebsunterbrechungsdeckung vollständig inkludiert"
      ],
      recommendation: "Empfohlene Deckung: 1.000.000 - 2.000.000 €"
    },
    {
      icon: Building2,
      title: "MVZ & Praxisgemeinschaften",
      description: "Mehrere Standorte mit vernetzten IT-Systemen",
      benefits: [
        "Alle Standorte zentral unter einem Vertrag versichert",
        "Weltweiter Schutz für internationale Datenströme",
        "Höhere Deckungssummen bis zu 5 Millionen Euro",
        "Persönlicher Schadenmanager für komplexe Fälle"
      ],
      recommendation: "Empfohlene Deckung: 2.000.000 - 3.000.000 €"
    },
    {
      icon: Hospital,
      title: "Kliniken & Krankenhäuser",
      description: "Große medizinische Einrichtungen mit kritischer IT-Infrastruktur",
      benefits: [
        "Maximalschutz mit Deckung bis zu 5 Millionen Euro",
        "Sofortige Krisenintervention bei akuten Großschäden",
        "Unbegrenzte Sublimits für sämtliche Schadenskategorien",
        "Spezialisiertes Krisenmanagement rund um die Uhr"
      ],
      recommendation: "Empfohlene Deckung: 3.000.000 - 5.000.000 €"
    }
  ];

  const insuranceConditions = [
    {
      icon: Shield,
      title: "Selbstbehalt",
      description: "Flexibler Selbstbehalt ab 250 €. Individuelle Anpassung für optimale Prämie. Höhere Selbstbehalte reduzieren den Beitrag."
    },
    {
      icon: CheckCircle2,
      title: "Deckungssummen",
      description: "Flexible Summen bis zu 5 Millionen €. Anpassbar an Praxisgröße und Risikoprofil. Empfohlen: Einzelpraxen 500.000-1 Mio. €."
    },
    {
      icon: Phone,
      title: "24/7-Notfall-Hotline",
      description: "Rund um die Uhr erreichbar mit sofortiger Vermittlung von IT-Forensikern und Rechtsanwälten. Auch an Wochenenden."
    },
    {
      icon: Clock,
      title: "Schnelle Regulierung",
      description: "Erfahrenes Schadenteam mit durchschnittlicher Bearbeitungszeit von unter 48 Stunden. Persönlicher Ansprechpartner."
    },
    {
      icon: FileText,
      title: "Kündigungsfrist",
      description: "3 Monate zum Vertragsende. Bei Nichtkündigung automatische Verlängerung. Sonderkündigungsrecht nach Schadensfall."
    },
    {
      icon: Award,
      title: "Unbegrenzte Sublimits",
      description: "Keine Begrenzung einzelner Schadenskategorien. Volle Deckungssumme für jeden Bereich. Digital Star ausgezeichnet."
    }
  ];

  const faqs = [
    {
      question: "Was macht die VHV CYBERPROTECT 3.0 besonders?",
      answer: "Die VHV CYBERPROTECT 3.0 wurde mehrfach ausgezeichnet (FFF-Rating von Franke & Bornberg, 'Sehr Gut' von Assekurata) und bietet unbegrenzte Sublimits sowie weltweiten Schutz. Als 'Digital Star' kombiniert sie umfassenden Schutz mit innovativen Assistance-Leistungen."
    },
    {
      question: "Welche Deckungssummen sind verfügbar?",
      answer: "Die VHV CYBERPROTECT 3.0 bietet flexible Deckungssummen bis zu 5 Millionen Euro. Die optimale Höhe richtet sich nach der Praxisgröße, der Anzahl der Patientendaten und dem Digitalisierungsgrad Ihrer IT-Infrastruktur."
    },
    {
      question: "Sind Prävention und Soforthilfe enthalten?",
      answer: "Ja, die VHV bietet umfassende Präventionsleistungen sowie eine 24/7-Notfall-Hotline. Im Schadensfall erhalten Sie sofortige Unterstützung durch IT-Forensiker, Rechtsanwälte und Krisenmanager."
    },
    {
      question: "Wie schnell greift der Versicherungsschutz?",
      answer: "Der Versicherungsschutz beginnt mit Vertragsabschluss und greift sofort bei neuen Cybervorfällen. Die 24/7-Hotline ist rund um die Uhr erreichbar und vermittelt innerhalb kürzester Zeit die passenden Spezialisten."
    },
    {
      question: "Gibt es Rabattmöglichkeiten?",
      answer: "Ja, bei Kombination mit anderen VHV-Versicherungen wie der Berufshaftpflicht oder Praxisausfallversicherung sind attraktive Bündelrabatte möglich. Sprechen Sie uns für ein individuelles Angebot an."
    },
    {
      question: "Was sind unbegrenzte Sublimits?",
      answer: "Anders als viele Wettbewerber begrenzt die VHV einzelne Schadenskategorien nicht durch Sublimits. Die volle Deckungssumme steht für jeden Schadenbereich zur Verfügung – für maximale Flexibilität im Ernstfall."
    },
    {
      question: "Gibt es eine Wartezeit nach Vertragsabschluss?",
      answer: "Nein, der Versicherungsschutz beginnt sofort nach Vertragsbeginn ohne Wartezeit. Bereits ab dem ersten Tag sind Sie vollständig geschützt."
    }
  ];

  const documents = [
    {
      title: "VHV CYBERPROTECT 3.0 Produktinformation",
      type: "PDF, ca. 800 KB",
      url: "/erstinformation.pdf"
    },
    {
      title: "Versicherungsbedingungen (AVB)",
      type: "PDF, ca. 1,3 MB",
      url: "/erstinformation.pdf"
    }
  ];

  return (
    <BaseTariffPage
      companyName="VHV"
      companyColor={VHV_COLOR}
      productRating={{ value: 4.7, count: 423 }}
      priceRange="55-210"
      pageTitle="VHV CYBERPROTECT 3.0 | Ausgezeichnete Cyberversicherung für Arztpraxen"
      metaDescription="VHV CYBERPROTECT 3.0 – mehrfach ausgezeichneter Cyberschutz (FFF-Rating, Digital Star) mit unbegrenzten Sublimits bis 5 Mio. € für medizinische Einrichtungen."
      metaKeywords="VHV Cyberversicherung, CYBERPROTECT 3.0, Arztpraxis Cyberschutz, VHV Digital Star, unbegrenzte Sublimits"
      canonicalUrl="https://praxis-versichert.de/tarifwissen/vhv"
      heroLabel="Digital Star & FFF-Rating – Mehrfach ausgezeichnet"
      heroTitle="VHV CYBERPROTECT 3.0 für medizinische Praxen"
      heroDescription="Mehrfach prämiert von Franke & Bornberg und Assekurata. Mit unbegrenzten Sublimits und weltweitem Schutz für maximale Sicherheit Ihrer medizinischen IT-Infrastruktur."
      heroFeatures={heroFeatures}
      alertTitle="Warum VHV?"
      alertDescription="Die VHV CYBERPROTECT 3.0 wurde als 'Digital Star' ausgezeichnet und erhielt das FFF-Rating von Franke & Bornberg sowie 'Sehr Gut' von Assekurata. Unbegrenzte Sublimits bedeuten: Die volle Deckungssumme steht für jeden Schadenbereich zur Verfügung – ohne versteckte Obergrenzen."
      coverageAreas={coverageAreas}
      targetGroups={targetGroups}
      insuranceConditions={insuranceConditions}
      faqs={faqs}
      documents={documents}
    />
  );
};

export default VhvTarif;
